import React from "react";
import { useTranslation } from "react-i18next";
import { creditPoolUsed } from "util/planEntitlements";
import PlanProgressBar from "./PlanProgressBar";
import styles from "./style.module.scss";

const CREDIT_LABEL_KEYS = {
  industry_expert: "settings.plan_credit_industry_expert",
  genai_complete_analysis: "settings.plan_credit_genai",
};

const PlanCreditPools = ({ creditPools = [], products = [], loading }) => {
  const { t } = useTranslation();

  const productNameByKey = (products || []).reduce((acc, product) => {
    const key = product.product_key || product.key;
    if (key) acc[key] = product.name;
    return acc;
  }, {});

  if (!creditPools.length) {
    return null;
  }

  return (
    <div className={styles.content}>
      <h3 className={styles.header}>{t("settings.plan_credit_pools_title")}</h3>
      <p className={styles.sectionHint}>{t("settings.plan_credit_pools_hint")}</p>
      {loading ? (
        <p className={styles.sectionHint}>{t("settings.plan_loading")}</p>
      ) : null}
      <div className={styles.creditGrid}>
        {creditPools.map((pool) => {
          const key = pool.product_key;
          const bundle = Number(pool.credit_bundle_size ?? 0);
          const used = creditPoolUsed(pool);
          const labelKey = CREDIT_LABEL_KEYS[key];
          const title =
            (labelKey ? t(labelKey) : null) ||
            productNameByKey[key] ||
            key;

          return (
            <div key={key} className={styles.creditCard}>
              <PlanProgressBar
                label={title}
                used={used}
                max={bundle > 0 ? bundle : null}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PlanCreditPools;
